/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('tool');
const TOOL_VIDEO_LIST = "TOOL_VIDEO_LIST";
const TOOL_DOMAIN_LIST = "TOOL_DOMAIN_LIST";
const TOOL_ADD = "TOOL_ADD";
const TOOL_DELETE = "TOOL_DELETE";
const TOOL_EDIT = "TOOL_EDIT";
const TOOL_DETAIL = "TOOL_DETAIL";

const APP_INFO = "APP_INFO";
const APP_UPDATE = "APP_UPDATE";

export default {
    TOOL_VIDEO_LIST,
    toolVideoList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:TOOL_VIDEO_LIST,
                data
            })
        })
    },
    TOOL_DOMAIN_LIST,
    toolDomainList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:TOOL_DOMAIN_LIST,
                data
            })
        })
    },
    TOOL_ADD,
    toolAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:TOOL_ADD,
                data
            })
        })
    },
    TOOL_DELETE,
    toolDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:TOOL_DELETE,
                data,
            })
        })
    },
    TOOL_EDIT,
    toolEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:TOOL_EDIT,
                data,
            })
        })
    },
    TOOL_DETAIL,
    toolDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:TOOL_DETAIL,
                data,
            })
        })
    },
    APP_INFO,
    appInfo:()=>{
        return ajaxCommon({
            api:{
                url:'/api/common/appinfo',
                method:'get'
            },
            success:(data)=>({
                type:APP_INFO,
                data
            })
        })
    },
    APP_UPDATE,
    appUpdate:(info)=>{
        return ajaxCommon({
            api:{
                url:'/api/common/appupdate',
                method:'post'
            },
            data:info,
            success:(data)=>({
                type:APP_UPDATE,
                data
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/ToolAction.js